import * as React from 'react';

import { Grid, Typography, Typography2 } from '@coursera/cds-core';

import ContextualHelpDialog from 'bundles/program-loggedin-shared/components/ContextualHelpDialog';

import _t from 'i18n!nls/degree-home';

const DisclaimersDialog: React.FC = () => {
  const disclaimers = [
    {
      title: _t('Exceptions, grade replacements, overrides'),
      message: _t(
        'The GPA shown on this page does not support exceptions, grade replacement policies or overrides. Verify your GPA and official progress with your program staff,  or please refer to your university’s record.'
      ),
    },
    {
      title: _t('Transfer credits'),
      message: _t(
        "Credits transferred from other institutions or degree programs may not be tracked on this page. For the most accurate record of your graduation progress, please refer to your university's records."
      ),
    },
    {
      title: _t('GPA calculation'),
      message: _t(
        "Grades from courses outside of Coursera are not included in the GPA shown on this page. For the most accurate GPA, refer to your university's records."
      ),
    },
    {
      title: _t('GPA for good standing'),
      message: _t(
        'Your program may have additional GPA requirements, including a minimum GPA each term to maintain good academic standing. Please refer to your university’s record and reach out to the program support team for more information.'
      ),
    },
  ];
  return (
    <div>
      <ContextualHelpDialog
        data-testid="info-icon"
        label={
          <Typography2 variant="bodyPrimary" component="span">
            {_t('Not what you expected?')}
          </Typography2>
        }
        ariaLabel={_t('Show disclaimers')}
        dialogHeading={_t('Disclaimers')}
      >
        <Grid container spacing={16}>
          {disclaimers.map((disclaimer) => (
            <React.Fragment key={disclaimer.title}>
              <Grid item>
                <Typography variant="h2semibold" component="h3">
                  {disclaimer.title}
                </Typography>
              </Grid>
              <Grid item>
                <Typography2 component="p">{disclaimer.message}</Typography2>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </ContextualHelpDialog>
    </div>
  );
};

export default DisclaimersDialog;
